import React, { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

const OvOvulatoryEventSurface: FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...attributes
}) => <Surface {...attributes}>{children}</Surface>;

export default OvOvulatoryEventSurface;

const Surface = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
  min-width: 0;
  overflow-x: auto;
  padding: 1rem 1.25rem;
  border-radius: ${Variables.borderRadius.LARGE};
  background: ${Colours.WHITE};
  box-shadow: ${Variables.boxShadow.defaultBox};
`;
